import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';

import { ILocalization } from '@shared-ui/localization-context';

import { RoomViewModel } from 'src/common/models';

import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { UitkGalleryCarousel } from 'uitk-react-gallery-carousel';

export interface RoomPhotosSegmentProps {
  analytics?: AnalyticsStore;
  l10n?: ILocalization;
  position?: string;
  room: RoomViewModel;
}

export const RoomPhotosSegment = ({ analytics, l10n, position, room }: RoomPhotosSegmentProps) => {
  const photos = room?.photos;
  const hasPosition = position || position === '0';

  if (!(photos && photos.length > 0 && hasPosition)) return null;

  const carousel = (
    <UitkGalleryCarousel
      allyHeadingText={l10n && l10n.formatText('hotels.infosite.gallery.viewAll.title')}
      analytics={analytics && analytics.setupTracker('RoomInfoDialog', 'Change image in carousel')}
      carouselName="PhotoGallery"
      images={photos}
      showGalleryButton={false}
      ratio={UitkFigureAspectRatioType.R16_9}
    />
  );

  const singlePhoto = (
    <UitkFigure>
      <UitkImage placeholderImage={true} src={photos[0].src} alt={photos[0].alt} />
    </UitkFigure>
  );

  return photos?.length > 1 ? carousel : singlePhoto;
};

RoomPhotosSegment.displayName = 'RoomPhotosSegment';
